import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { DxTextBoxComponent } from "devextreme-angular/ui/text-box";
import { AmsNotifierService } from "src/app/shared/services/ams-notifier.service";
import { LanguageService } from "src/app/shared/services/language.service";
import { UserService } from "src/app/shared/services/user.service";
import { EmployeeService } from "../../employee/_api/services/employee.service";
import { PasswordValidatorService, ValidationResult } from "../password-validator.service";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  @Input() userId: string;
  @Input() employeeName: string;
  @Input() changePasswordAtNextLogin = false;
  @Input() canCloseWithoutSaving = true;
  @Input() popupVisible = false;

  @Output() closed = new EventEmitter<void>();

  user = "";
  password = "";
  verifiedPassword = "";

  enforcePasswordRules = false;
  passwordRules = [];
  passwordIsValid = false;
  passwordIsVerified = false;

  isBusy = false;

  @ViewChild('pwd') passwordInput: DxTextBoxComponent;

  constructor(public languageService: LanguageService, private userService: UserService, private employeeService: EmployeeService, private notifier: AmsNotifierService, private validator: PasswordValidatorService) {}

  ngOnInit() {
    const isCurrentUser = !this.userId;

    this.userId = isCurrentUser ? this.userService.userId : this.userId;
    this.employeeName = isCurrentUser ? this.userService.account.Name : this.employeeName;

    this.user = `${this.employeeName} (${this.userId})`;
    this.enforcePasswordRules = this.userService.mustEnforcePasswordRules();

    const passwordRules = this.languageService.LNG("Label.PasswordRules").split("|");
    passwordRules.forEach((r: any) => this.passwordRules.push({ text: r, satisfied: false }));
  }

  passwordComparison = () => {
    return this.password;
  };

  validatePassword(password: string) {
    if (password.length > 0 && !this.enforcePasswordRules) {
      this.passwordIsValid = true;
      return;
    }

    const result = this.validator.isValid(password);

    this.checkForSatisfiedValidationRules(result);
    this.passwordIsValid = result.allRulesAreSatisfied;
  }

  private checkForSatisfiedValidationRules(result: ValidationResult) {
    this.passwordRules[0].satisfied = result.isLongEnough;
    this.passwordRules[1].satisfied = result.hasUppercase;
    this.passwordRules[2].satisfied = result.hasLowercase;
    this.passwordRules[3].satisfied = result.hasNumber;
    this.passwordRules[4].satisfied = result.hasSpecialCharacter;
  }

  validateVerifiedPassword(verifiedPassword: string) {
    this.passwordIsVerified = this.password === verifiedPassword;
  }

  async onChangePassword() {
    if (this.isBusy) { return; }

    this.isBusy = true;
    try {
      await this.employeeService.changeLoginCredentials(this.userId, this.userId, this.password, this.changePasswordAtNextLogin).toPromise();
      this.popupVisible = false;
      this.closed.emit();
    } catch (error) {
        this.notifier.errorWithForcedTimeout(error.message);
    } finally {
      this.isBusy = false;
    }
  }

  onShown() {
    this.passwordInput.instance.focus();
  }

  onHiding() {
    this.popupVisible = false;
    this.closed.emit();
  }
}
